module.exports = __webpack_public_path__ + "static/media/am_applepay.png";